<div class="wrap-name">
    <div class="circle ellipsis" [ngClass]="{'light-blue':isCreator}">
        <p *ngIf="user?.firstName?.charAt(0)"> {{user!.firstName!.charAt(0).toUpperCase()}}</p>
        <p *ngIf="user?.lastName?.charAt(0)">{{user!.lastName!.charAt(0).toUpperCase()}}</p>
    </div>

    <div *ngIf="displayTooltip">
        <div class="tooltip-abs" *ngIf="user?.firstName && user?.lastName">
            <p>{{user?.firstName}} {{user?.lastName}}</p>
        </div>
    </div>
</div>